import { defineComponent as nt, watchEffect as fe, ref as u, computed as X, watch as q, nextTick as J, onMounted as st, provide as it, toRef as x, h as i, withDirectives as lt, vShow as ot, TransitionGroup as rt, cloneVNode as dt } from "vue";
import { tabsInjectionKey as ft } from "./ghl-ui.es1106.js";
import ae from "./ghl-ui.es198.js";
import ct from "./ghl-ui.es1107.js";
import { warnOnce as Q } from "./ghl-ui.es853.js";
import ut from "./ghl-ui.es854.js";
import me from "./ghl-ui.es855.js";
import ce from "./ghl-ui.es714.js";
import { flatten as Y } from "./ghl-ui.es932.js";
import pt from "./ghl-ui.es712.js";
import Z from "./ghl-ui.es1108.js";
import bt from "./ghl-ui.es707.js";
import { createKey as R } from "./ghl-ui.es384.js";
import { getMargin as k, depx as ht } from "./ghl-ui.es856.js";
import { useThemeClass as mt } from "./ghl-ui.es857.js";
import { resolveWrappedSlot as ue } from "./ghl-ui.es860.js";
import ee from "./ghl-ui.es887.js";
import vt from "./ghl-ui.es748.js";
import gt from "./ghl-ui.es1109.js";
import { call as U } from "./ghl-ui.es876.js";
const yt = Object.assign(Object.assign({}, me.props), {
  value: [String, Number],
  defaultValue: [String, Number],
  trigger: {
    type: String,
    default: "click"
  },
  type: {
    type: String,
    default: "bar"
  },
  closable: Boolean,
  justifyContent: String,
  size: {
    type: String,
    default: "medium"
  },
  placement: {
    type: String,
    default: "top"
  },
  tabStyle: [String, Object],
  tabClass: String,
  addTabStyle: [String, Object],
  addTabClass: String,
  barWidth: Number,
  paneClass: String,
  paneStyle: [String, Object],
  paneWrapperClass: String,
  paneWrapperStyle: [String, Object],
  addable: [Boolean, Object],
  tabsPadding: {
    type: Number,
    default: 0
  },
  animated: Boolean,
  onBeforeLeave: Function,
  onAdd: Function,
  "onUpdate:value": [Function, Array],
  onUpdateValue: [Function, Array],
  onClose: [Function, Array],
  // deprecated
  labelSize: String,
  activeName: [String, Number],
  onActiveNameChange: [Function, Array]
}), It = nt({
  name: "Tabs",
  props: yt,
  setup(a, {
    slots: r
  }) {
    var $, P, m, _;
    process.env.NODE_ENV !== "production" && fe(() => {
      a.labelSize !== void 0 && Q("tabs", "`label-size` is deprecated, please use `size` instead."), a.activeName !== void 0 && Q("tabs", "`active-name` is deprecated, please use `value` instead."), a.onActiveNameChange !== void 0 && Q("tabs", "`on-active-name-change` is deprecated, please use `on-update:value` instead.");
    });
    const {
      mergedClsPrefixRef: d,
      inlineThemeDisabled: y
    } = ut(a), T = me("Tabs", "-tabs", ct, gt, a, d), v = u(null), p = u(null), B = u(null), L = u(null), f = u(null), b = u(null), z = u(!0), S = u(!0), A = ce(a, ["labelSize", "size"]), g = ce(a, ["activeName", "value"]), O = u((P = ($ = g.value) !== null && $ !== void 0 ? $ : a.defaultValue) !== null && P !== void 0 ? P : r.default ? (_ = (m = Y(r.default())[0]) === null || m === void 0 ? void 0 : m.props) === null || _ === void 0 ? void 0 : _.name : null), h = pt(g, O), l = {
      id: 0
    }, c = X(() => {
      if (!(!a.justifyContent || a.type === "card"))
        return {
          display: "flex",
          justifyContent: a.justifyContent
        };
    });
    q(h, () => {
      l.id = 0, D(), se();
    });
    function w() {
      var t;
      const {
        value: e
      } = h;
      return e === null ? null : (t = v.value) === null || t === void 0 ? void 0 : t.querySelector(`[data-name="${e}"]`);
    }
    function ve(t) {
      if (a.type === "card")
        return;
      const {
        value: e
      } = p;
      if (!e)
        return;
      const n = e.style.opacity === "0";
      if (t) {
        const s = `${d.value}-tabs-bar--disabled`, {
          barWidth: o,
          placement: W
        } = a;
        if (t.dataset.disabled === "true" ? e.classList.add(s) : e.classList.remove(s), ["top", "bottom"].includes(W)) {
          if (ne(["top", "maxHeight", "height"]), typeof o == "number" && t.offsetWidth >= o) {
            const C = Math.floor((t.offsetWidth - o) / 2) + t.offsetLeft;
            e.style.left = `${C}px`, e.style.maxWidth = `${o}px`;
          } else
            e.style.left = `${t.offsetLeft}px`, e.style.maxWidth = `${t.offsetWidth}px`;
          e.style.width = "8192px", n && (e.style.transition = "none"), e.offsetWidth, n && (e.style.transition = "", e.style.opacity = "1");
        } else {
          if (ne(["left", "maxWidth", "width"]), typeof o == "number" && t.offsetHeight >= o) {
            const C = Math.floor((t.offsetHeight - o) / 2) + t.offsetTop;
            e.style.top = `${C}px`, e.style.maxHeight = `${o}px`;
          } else
            e.style.top = `${t.offsetTop}px`, e.style.maxHeight = `${t.offsetHeight}px`;
          e.style.height = "8192px", n && (e.style.transition = "none"), e.offsetHeight, n && (e.style.transition = "", e.style.opacity = "1");
        }
      }
    }
    function ge() {
      if (a.type === "card")
        return;
      const {
        value: t
      } = p;
      t && (t.style.opacity = "0");
    }
    function ne(t) {
      const {
        value: e
      } = p;
      if (e)
        for (const n of t)
          e.style[n] = "";
    }
    function D() {
      if (a.type === "card")
        return;
      const t = w();
      t ? ve(t) : ge();
    }
    function se(t) {
      var e;
      const n = (e = f.value) === null || e === void 0 ? void 0 : e.$el;
      if (!n)
        return;
      const s = w();
      if (!s)
        return;
      const {
        scrollLeft: o,
        offsetWidth: W
      } = n, {
        offsetLeft: C,
        offsetWidth: V
      } = s;
      o > C ? n.scrollTo({
        top: 0,
        left: C,
        behavior: "smooth"
      }) : C + V > o + W && n.scrollTo({
        top: 0,
        left: C + V - W,
        behavior: "smooth"
      });
    }
    const F = u(null);
    let G = 0, E = null;
    function ye(t) {
      const e = F.value;
      if (e) {
        G = t.getBoundingClientRect().height;
        const n = `${G}px`, s = () => {
          e.style.height = n, e.style.maxHeight = n;
        };
        E ? (s(), E(), E = null) : E = s;
      }
    }
    function Se(t) {
      const e = F.value;
      if (e) {
        const n = t.getBoundingClientRect().height, s = () => {
          document.body.offsetHeight, e.style.maxHeight = `${n}px`, e.style.height = `${Math.max(G, n)}px`;
        };
        E ? (E(), E = null, s()) : E = s;
      }
    }
    function Ce() {
      const t = F.value;
      if (t) {
        t.style.maxHeight = "", t.style.height = "";
        const {
          paneWrapperStyle: e
        } = a;
        if (typeof e == "string")
          t.style.cssText = e;
        else if (e) {
          const {
            maxHeight: n,
            height: s
          } = e;
          n !== void 0 && (t.style.maxHeight = n), s !== void 0 && (t.style.height = s);
        }
      }
    }
    const ie = {
      value: []
    }, le = u("next");
    function xe(t) {
      const e = h.value;
      let n = "next";
      for (const s of ie.value) {
        if (s === e)
          break;
        if (s === t) {
          n = "prev";
          break;
        }
      }
      le.value = n, Re(t);
    }
    function Re(t) {
      const {
        onActiveNameChange: e,
        onUpdateValue: n,
        "onUpdate:value": s
      } = a;
      e && U(e, t), n && U(n, t), s && U(s, t), O.value = t;
    }
    function $e(t) {
      const {
        onClose: e
      } = a;
      e && U(e, t);
    }
    function oe() {
      const {
        value: t
      } = p;
      if (!t)
        return;
      const e = "transition-disabled";
      t.classList.add(e), D(), t.classList.remove(e);
    }
    const H = u(null);
    function N({
      transitionDisabled: t
    }) {
      const e = v.value;
      if (!e)
        return;
      t && e.classList.add("transition-disabled");
      const n = w();
      n && H.value && (H.value.style.width = `${n.offsetWidth}px`, H.value.style.height = `${n.offsetHeight}px`, H.value.style.transform = `translateX(${n.offsetLeft - e.offsetLeft - ht(getComputedStyle(e).paddingLeft)}px)`, t && H.value.offsetWidth), t && e.classList.remove("transition-disabled");
    }
    q([h], () => {
      a.type === "segment" && J(() => {
        N({
          transitionDisabled: !1
        });
      });
    }), st(() => {
      a.type === "segment" && N({
        transitionDisabled: !0
      });
    });
    let re = 0;
    function Te(t) {
      var e;
      if (t.contentRect.width === 0 && t.contentRect.height === 0 || re === t.contentRect.width)
        return;
      re = t.contentRect.width;
      const {
        type: n
      } = a;
      if ((n === "line" || n === "bar") && oe(), n !== "segment") {
        const {
          placement: s
        } = a;
        K((s === "top" || s === "bottom" ? (e = f.value) === null || e === void 0 ? void 0 : e.$el : b.value) || null);
      }
    }
    const We = Z(Te, 64);
    q([() => a.justifyContent, () => a.size], () => {
      J(() => {
        const {
          type: t
        } = a;
        (t === "line" || t === "bar") && oe();
      });
    });
    const I = u(!1);
    function Pe(t) {
      var e;
      const {
        target: n,
        contentRect: {
          width: s
        }
      } = t, o = n.parentElement.offsetWidth;
      if (!I.value)
        o < s && (I.value = !0);
      else {
        const {
          value: W
        } = L;
        if (!W)
          return;
        o - s > W.$el.offsetWidth && (I.value = !1);
      }
      K(((e = f.value) === null || e === void 0 ? void 0 : e.$el) || null);
    }
    const Le = Z(Pe, 64);
    function ze() {
      const {
        onAdd: t
      } = a;
      t && t(), J(() => {
        const e = w(), {
          value: n
        } = f;
        !e || !n || n.scrollTo({
          left: e.offsetLeft,
          top: 0,
          behavior: "smooth"
        });
      });
    }
    function K(t) {
      if (!t)
        return;
      const {
        placement: e
      } = a;
      if (e === "top" || e === "bottom") {
        const {
          scrollLeft: n,
          scrollWidth: s,
          offsetWidth: o
        } = t;
        z.value = n <= 0, S.value = n + o >= s;
      } else {
        const {
          scrollTop: n,
          scrollHeight: s,
          offsetHeight: o
        } = t;
        z.value = n <= 0, S.value = n + o >= s;
      }
    }
    const we = Z((t) => {
      K(t.target);
    }, 64);
    it(ft, {
      triggerRef: x(a, "trigger"),
      tabStyleRef: x(a, "tabStyle"),
      tabClassRef: x(a, "tabClass"),
      addTabStyleRef: x(a, "addTabStyle"),
      addTabClassRef: x(a, "addTabClass"),
      paneClassRef: x(a, "paneClass"),
      paneStyleRef: x(a, "paneStyle"),
      mergedClsPrefixRef: d,
      typeRef: x(a, "type"),
      closableRef: x(a, "closable"),
      valueRef: h,
      tabChangeIdRef: l,
      onBeforeLeaveRef: x(a, "onBeforeLeave"),
      activateTab: xe,
      handleClose: $e,
      handleAdd: ze
    }), bt(() => {
      D(), se();
    }), fe(() => {
      const {
        value: t
      } = B;
      if (!t)
        return;
      const {
        value: e
      } = d, n = `${e}-tabs-nav-scroll-wrapper--shadow-start`, s = `${e}-tabs-nav-scroll-wrapper--shadow-end`;
      z.value ? t.classList.remove(n) : t.classList.add(n), S.value ? t.classList.remove(s) : t.classList.add(s);
    });
    const Ee = {
      syncBarPosition: () => {
        D();
      }
    }, _e = () => {
      N({
        transitionDisabled: !0
      });
    }, de = X(() => {
      const {
        value: t
      } = A, {
        type: e
      } = a, n = {
        card: "Card",
        bar: "Bar",
        line: "Line",
        segment: "Segment"
      }[e], s = `${t}${n}`, {
        self: {
          barColor: o,
          closeIconColor: W,
          closeIconColorHover: C,
          closeIconColorPressed: V,
          tabColor: Ae,
          tabBorderColor: Be,
          paneTextColor: He,
          tabFontWeight: je,
          tabBorderRadius: Oe,
          tabFontWeightActive: De,
          colorSegment: Fe,
          fontWeightStrong: Ie,
          tabColorSegment: Ve,
          closeSize: Me,
          closeIconSize: ke,
          closeColorHover: Ue,
          closeColorPressed: Ge,
          closeBorderRadius: Ne,
          [R("panePadding", t)]: M,
          [R("tabPadding", s)]: Ke,
          [R("tabPaddingVertical", s)]: Xe,
          [R("tabGap", s)]: qe,
          [R("tabGap", `${s}Vertical`)]: Je,
          [R("tabTextColor", e)]: Qe,
          [R("tabTextColorActive", e)]: Ye,
          [R("tabTextColorHover", e)]: Ze,
          [R("tabTextColorDisabled", e)]: et,
          [R("tabFontSize", t)]: tt
        },
        common: {
          cubicBezierEaseInOut: at
        }
      } = T.value;
      return {
        "--n-bezier": at,
        "--n-color-segment": Fe,
        "--n-bar-color": o,
        "--n-tab-font-size": tt,
        "--n-tab-text-color": Qe,
        "--n-tab-text-color-active": Ye,
        "--n-tab-text-color-disabled": et,
        "--n-tab-text-color-hover": Ze,
        "--n-pane-text-color": He,
        "--n-tab-border-color": Be,
        "--n-tab-border-radius": Oe,
        "--n-close-size": Me,
        "--n-close-icon-size": ke,
        "--n-close-color-hover": Ue,
        "--n-close-color-pressed": Ge,
        "--n-close-border-radius": Ne,
        "--n-close-icon-color": W,
        "--n-close-icon-color-hover": C,
        "--n-close-icon-color-pressed": V,
        "--n-tab-color": Ae,
        "--n-tab-font-weight": je,
        "--n-tab-font-weight-active": De,
        "--n-tab-padding": Ke,
        "--n-tab-padding-vertical": Xe,
        "--n-tab-gap": qe,
        "--n-tab-gap-vertical": Je,
        "--n-pane-padding-left": k(M, "left"),
        "--n-pane-padding-right": k(M, "right"),
        "--n-pane-padding-top": k(M, "top"),
        "--n-pane-padding-bottom": k(M, "bottom"),
        "--n-font-weight-strong": Ie,
        "--n-tab-color-segment": Ve
      };
    }), j = y ? mt("tabs", X(() => `${A.value[0]}${a.type[0]}`), de, a) : void 0;
    return Object.assign({
      mergedClsPrefix: d,
      mergedValue: h,
      renderedNames: /* @__PURE__ */ new Set(),
      segmentCapsuleElRef: H,
      tabsPaneWrapperRef: F,
      tabsElRef: v,
      barElRef: p,
      addTabInstRef: L,
      xScrollInstRef: f,
      scrollWrapperElRef: B,
      addTabFixed: I,
      tabWrapperStyle: c,
      handleNavResize: We,
      mergedSize: A,
      handleScroll: we,
      handleTabsResize: Le,
      cssVars: y ? void 0 : de,
      themeClass: j == null ? void 0 : j.themeClass,
      animationDirection: le,
      renderNameListRef: ie,
      yScrollElRef: b,
      handleSegmentResize: _e,
      onAnimationBeforeLeave: ye,
      onAnimationEnter: Se,
      onAnimationAfterEnter: Ce,
      onRender: j == null ? void 0 : j.onRender
    }, Ee);
  },
  render() {
    const {
      mergedClsPrefix: a,
      type: r,
      placement: $,
      addTabFixed: P,
      addable: m,
      mergedSize: _,
      renderNameListRef: d,
      onRender: y,
      paneWrapperClass: T,
      paneWrapperStyle: v,
      $slots: {
        default: p,
        prefix: B,
        suffix: L
      }
    } = this;
    y == null || y();
    const f = p ? Y(p()).filter((l) => l.type.__TAB_PANE__ === !0) : [], b = p ? Y(p()).filter((l) => l.type.__TAB__ === !0) : [], z = !b.length, S = r === "card", A = r === "segment", g = !S && !A && this.justifyContent;
    d.value = [];
    const O = () => {
      const l = i("div", {
        style: this.tabWrapperStyle,
        class: [`${a}-tabs-wrapper`]
      }, g ? null : i("div", {
        class: `${a}-tabs-scroll-padding`,
        style: {
          width: `${this.tabsPadding}px`
        }
      }), z ? f.map((c, w) => (d.value.push(c.props.name), te(i(ae, Object.assign({}, c.props, {
        internalCreatedByPane: !0,
        internalLeftPadded: w !== 0 && (!g || g === "center" || g === "start" || g === "end")
      }), c.children ? {
        default: c.children.tab
      } : void 0)))) : b.map((c, w) => (d.value.push(c.props.name), te(w !== 0 && !g ? he(c) : c))), !P && m && S ? be(m, (z ? f.length : b.length) !== 0) : null, g ? null : i("div", {
        class: `${a}-tabs-scroll-padding`,
        style: {
          width: `${this.tabsPadding}px`
        }
      }));
      return i("div", {
        ref: "tabsElRef",
        class: `${a}-tabs-nav-scroll-content`
      }, S && m ? i(ee, {
        onResize: this.handleTabsResize
      }, {
        default: () => l
      }) : l, S ? i("div", {
        class: `${a}-tabs-pad`
      }) : null, S ? null : i("div", {
        ref: "barElRef",
        class: `${a}-tabs-bar`
      }));
    }, h = A ? "top" : $;
    return i("div", {
      class: [`${a}-tabs`, this.themeClass, `${a}-tabs--${r}-type`, `${a}-tabs--${_}-size`, g && `${a}-tabs--flex`, `${a}-tabs--${h}`],
      style: this.cssVars
    }, i("div", {
      class: [
        // the class should be applied here since it's possible
        // to make tabs nested in tabs, style may influence each
        // other. adding a class will make it easy to write the
        // style.
        `${a}-tabs-nav--${r}-type`,
        `${a}-tabs-nav--${h}`,
        `${a}-tabs-nav`
      ]
    }, ue(B, (l) => l && i("div", {
      class: `${a}-tabs-nav__prefix`
    }, l)), A ? i(ee, {
      onResize: this.handleSegmentResize
    }, {
      default: () => i("div", {
        class: `${a}-tabs-rail`,
        ref: "tabsElRef"
      }, i("div", {
        class: `${a}-tabs-capsule`,
        ref: "segmentCapsuleElRef"
      }, i("div", {
        class: `${a}-tabs-wrapper`
      }, i("div", {
        class: `${a}-tabs-tab`
      }))), z ? f.map((l, c) => (d.value.push(l.props.name), i(ae, Object.assign({}, l.props, {
        internalCreatedByPane: !0,
        internalLeftPadded: c !== 0
      }), l.children ? {
        default: l.children.tab
      } : void 0))) : b.map((l, c) => (d.value.push(l.props.name), c === 0 ? l : he(l))))
    }) : i(ee, {
      onResize: this.handleNavResize
    }, {
      default: () => i("div", {
        class: `${a}-tabs-nav-scroll-wrapper`,
        ref: "scrollWrapperElRef"
      }, ["top", "bottom"].includes(h) ? i(vt, {
        ref: "xScrollInstRef",
        onScroll: this.handleScroll
      }, {
        default: O
      }) : i("div", {
        class: `${a}-tabs-nav-y-scroll`,
        onScroll: this.handleScroll,
        ref: "yScrollElRef"
      }, O()))
    }), P && m && S ? be(m, !0) : null, ue(L, (l) => l && i("div", {
      class: `${a}-tabs-nav__suffix`
    }, l))), z && (this.animated && (h === "top" || h === "bottom") ? i("div", {
      ref: "tabsPaneWrapperRef",
      style: v,
      class: [`${a}-tabs-pane-wrapper`, T]
    }, pe(f, this.mergedValue, this.renderedNames, this.onAnimationBeforeLeave, this.onAnimationEnter, this.onAnimationAfterEnter, this.animationDirection)) : pe(f, this.mergedValue, this.renderedNames)));
  }
});
function pe(a, r, $, P, m, _, d) {
  const y = [];
  return a.forEach((T) => {
    const {
      name: v,
      displayDirective: p,
      "display-directive": B
    } = T.props, L = (b) => p === b || B === b, f = r === v;
    if (T.key !== void 0 && (T.key = v), f || L("show") || L("show:lazy") && $.has(v)) {
      $.has(v) || $.add(v);
      const b = !L("if");
      y.push(b ? lt(T, [[ot, f]]) : T);
    }
  }), d ? i(rt, {
    name: `${d}-transition`,
    onBeforeLeave: P,
    onEnter: m,
    onAfterEnter: _
  }, {
    default: () => y
  }) : y;
}
function be(a, r) {
  return i(ae, {
    ref: "addTabInstRef",
    key: "__addable",
    name: "__addable",
    internalCreatedByPane: !0,
    internalAddable: !0,
    internalLeftPadded: r,
    disabled: typeof a == "object" && a.disabled
  });
}
function he(a) {
  const r = dt(a);
  return r.props ? r.props.internalLeftPadded = !0 : r.props = {
    internalLeftPadded: !0
  }, r;
}
function te(a) {
  return Array.isArray(a.dynamicProps) ? a.dynamicProps.includes("internalLeftPadded") || a.dynamicProps.push("internalLeftPadded") : a.dynamicProps = ["internalLeftPadded"], a;
}
export {
  It as default,
  yt as tabsProps
};
